import React, { Component } from 'react';
import { Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from 'reactstrap';
import add from "../resources/images/estrategas/tools/add.png";
import * as Request from "../service/data-info-chart/requestsUtil";
import { SAVE_NEW } from "../utils/constants";

class AddNews extends Component{
  constructor(props) {
    super(props);
    this.toggleAddNews = this.toggleAddNews.bind(this);
    this.saveNew = this.saveNew.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state={ modalAddNew: false, image: new FormData(), title: '', body: '' }
  }

  toggleAddNews(){
    this.setState({ modalAddNew: !this.state.modalAddNew });
  }

  addImage = event => {
    const file = event.target.files[0];
    const fd = new FormData();

    if (file !== undefined) {
      fd.append('file', file);
      this.setState({ image: fd });
    }
  };

  saveNew(){

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };

    let fd = this.state.image;
    fd.append('title', this.state.title);
    fd.append('body', this.state.body);

    Request.postFetch2(SAVE_NEW, fd, config)
      .then(resp => {
        this.props.callbackFromParent();
      });
    this.setState({ modalAddNew: !this.state.modalAddNew });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  render() {
    return (
      <div>
        <Modal size={'lg'} isOpen={this.state.modalAddNew} toggle={this.toggleAddNews}>
          <ModalHeader className='header-modal'
                       toggle={this.toggleAddNews}>Noticias</ModalHeader>
          <ModalBody>
            <div className='pl-5 pr-5'>
              <FormGroup>
                <Label for="title">Titulo de la noticia: </Label>
                <Input
                  placeholder="Ingrese el texto"
                  type="text"
                  name="title"
                  value={this.state.title}
                  onChange={this.handleChange}
                  maxLength={100}/>
              </FormGroup>
              <FormGroup>
                <Label for="title">Información de la noticia: </Label>
                <Input
                  placeholder="Ingrese el texto"
                  type="textarea"
                  name="body"
                  value={this.state.body}
                  onChange={this.handleChange}
                  style={{height:'120px'}}
                  maxLength={500}
                />
              </FormGroup>
              <form action={''} method="post" encType="multipart/form-data">
                <input style={{ display: 'none' }} type="file" name="file"
                       id="exampleFile" onChange={this.addImage}
                       ref={fileInput => this.fileInput = fileInput}/>
                <Button color="success" onClick={() => this.fileInput.click()}>
                  Agregar una imagen</Button>
              </form>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveNew}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggleAddNews}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className='news-add-icon'>
          <img src={add} alt='' onClick={this.toggleAddNews}/>
        </div>
      </div>
    );
  }

}

export default AddNews;



// WEBPACK FOOTER //
// ./src/components/addNews.js